var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon / chevron.left",
    d: "M1.33594 7.95898C1.33594 8.21354 1.43327 8.43066 1.63542 8.62533L7.47526 14.3379C7.63249 14.5026 7.84212 14.585 8.08171 14.585C8.56836 14.585 8.9502 14.2106 8.9502 13.7165C8.9502 13.4769 8.85286 13.2598 8.68815 13.0951L3.4248 7.95898L8.68815 2.82292C8.85286 2.65072 8.9502 2.43359 8.9502 2.19401C8.9502 1.70736 8.56836 1.33301 8.08171 1.33301C7.84212 1.33301 7.63249 1.41536 7.47526 1.58008L1.63542 7.29264C1.43327 7.4873 1.34342 7.70443 1.33594 7.95898Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.0f16fced8d298221b932754a20e62fdd.svg";
export { ForwardRef as ReactComponent };